import React from "react";
import "../styles/navbar.scss";
import { getAuth, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { Language } from "./language";
import { texts } from "../lib/constants";

function Navbar({
  user,
  setUser,
  company,
  setShowModalProfile,
  language,
  changeLanguage,
  setUserProfile,
  isDesktop,
  isTablet,
  isMobile,
}) {
  const navigate = useNavigate();
  const logout = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        sessionStorage.clear();
        setUser();
        setUserProfile();
        navigate("/");
      })
      .catch((error) => {
        console.error("Error signout user:", error);
      });
  };

  return (
    <div className="navbar-div">
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          onClick={() => user && navigate("/home")}
          style={{ cursor: user ? "pointer" : "default" }}
          className="img-logo"
          src="/assets/img/logo-navbar.png"
          alt="logo"
        />
        {process.env.REACT_APP_LOGO_NAVBAR_COMPANY_IMAGE &&
          process.env.REACT_APP_LOGO_NAVBAR_COMPANY_IMAGE !== "" && (
            <img
              className="img-company"
              src="/assets/img/company.png"
              alt="company"
            />
          )}
      </div>
      {!user && (
        <div style={{ position: "absolute", right: "36px", top: "36x" }}>
          <Language language={language} changeLanguage={changeLanguage} />
        </div>
      )}
      <div>
        {user ? (
          <div className="user-info-div" style={{ width: "100%" }}>
            <div className="user-info">
              {/* Desktop y Tablet */}
              {(isDesktop || isTablet) && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginRight: "12px",
                  }}
                >
                  {/* Perfil */}
                  <p
                    className="text-body-3"
                    style={{ fontSize: "18px", paddingRight: "6px", marginBottom: "12px" }}
                  >
                    {texts[language].navbarWelcome} {user?.name} ·{" "}
                    {process.env.REACT_APP_COMPANY}
                  </p>
                  <p
                    onClick={() => setShowModalProfile(true)}
                    className="links"
                    style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <img
                      style={{ width: "20px", height: "20px" }}
                      src="/assets/img/icon-profile.png"
                      alt="profile"
                    />
                    {texts[language].navbarChangeProfile}
                  </p>

                  {/* Logout */}
                  <p
                    className="links"
                    onClick={logout}
                    style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "5px" }}
                  >
                    <img
                      style={{ width: "20px", height: "20px" }}
                      src="/assets/img/icon-logout.svg"
                      alt="logout"
                    />
                    {texts[language].logout}
                  </p>

                  {/* Idioma */}
                  <Language
                    userID={user.id}
                    language={language}
                    changeLanguage={changeLanguage}
                  />
                </div>
              )}

              {/* Móvil */}
              {isMobile && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    paddingRight: "12px",
                  }}
                >
                  {/* Perfil */}
                  <img
                    style={{ width: "32px", height: "32px", marginBottom: "12px" }}
                    src="/assets/img/icon-profile.png"
                    alt="profile"
                    onClick={() => setShowModalProfile(true)}
                  />

                  {/* Logout */}
                  <img
                    style={{ width: "24px", height: "24px", paddingLeft: "4px", marginBottom: "5px" }}
                    src="/assets/img/icon-logout.svg"
                    alt="logout"
                    onClick={logout}
                  />

                  {/* Idioma */}
                  <Language
                    userID={user.id}
                    language={language}
                    changeLanguage={changeLanguage}
                    isMobile={isMobile}
                  />
                </div>
              )}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default Navbar;
